module.exports = __webpack_public_path__ + "static/media/Montserrat-Variable.e6cb49ef.ttf";